import React from 'react';
import ProductsSection from '../Components/productsSection/ProductsSection';
//importing components
import ServicesSection from '../Components/servicesSection/ServicesSection';
import OurReviews from '../Components/reviews/OurReviews'
//importing styles
import styled from 'styled-components';
import FooterSection from '../Components/footer/FooterSection';
import HireUs from '../Components/hireUs/HireUs';
import OurWork from '../Components/ourWork/OurWork';
//importing banner
import banner from '../Images/home/banner.jpg';

function Home() {
    return (
        <div className="home">
            <header className="header">
                {/* <VideoBg autoPlay loop muted src={video} type='video/mp4' /> */}
                <ImgBg src={banner} alt="banner" />

                <div className="tagline">
                    <h1>We work to make your dreams come true</h1>
                    <h3>Offering complete IT support & services globally including several web development and web design services to provide all the desired solutions to clients at single a platform.</h3>
                    <div className="buttons">
                        <button className="portfolio">Portfolio</button>
                        <button className="contact">Contact Us</button>
                    </div>
                </div>
            </header>
            <ServicesSection />
            <ProductsSection />
            <OurReviews />
            <OurWork />
        </div>
    )
}

export default Home


const ImgBg = styled.img`
    z-index: -1;
    /* opacity: 0; */
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    --o-object-fit: cover;
    object-fit: cover;
`